"use strict";

import http from "@/http";

const BASE_NAME = "/email-templates";

const list = async () => (await http.get(BASE_NAME)).data;
const create = async template => (await http.post(BASE_NAME, template)).data;
const edit = async (id, template) => (await http.put(`${BASE_NAME}/${id}`, template)).data;
const remove = async id => { await http.delete(`${BASE_NAME}/${id}`); };
const listDeleted = async () => (await http.get(`${BASE_NAME}/deleted`)).data;
const restore = async id => (await http.post(`${BASE_NAME}/${id}/restore`)).data;
const preview = async draft => (await http.post(`${BASE_NAME}/preview`, draft)).data;
const purposes = async () => (await http.get(`${BASE_NAME}/lookup/purposes`)).data;
const visualStyles = async () => (await http.get(`${BASE_NAME}/lookup/visual-styles`)).data;

export default { list, listDeleted, create, edit, remove, restore, preview, purposes, visualStyles };
